import { useCallback, useContext, useEffect } from 'react';
import { Box } from '@nimbus-ds/components';
import { useToastStatus } from 'commons/hooks';
import { useGetCountry } from 'domains/Auth/hooks';
import {
  CreditCardForm,
  CheckoutContext,
} from 'domains/Billing/Checkout/CheckoutUI';
import { useCreditCardCheckout } from 'domains/Billing/Checkout/hooks';

export function PaymentInfo() {
  const { setOnPay, setStatus, setCreditCardFormError } =
    useContext(CheckoutContext);
  const country = useGetCountry();
  const {
    errors,
    formValues,
    setFieldValue,
    setupStatusObject: {
      isLoading: setupIsLoading,
      isError: setupIsError,
      isSuccess: setupIsSuccess,
    },
    status,
    formErrors,
    handleOnSubmit,
    cleanStatus,
  } = useCreditCardCheckout();

  useEffect(() => {
    if (setupIsSuccess && !setupIsError) {
      setOnPay(handleOnSubmit);
      setStatus(status);
      setCreditCardFormError(Object.keys(formErrors).length > 0);
    }
  }, [
    setupIsSuccess,
    setupIsError,
    setOnPay,
    handleOnSubmit,
    status,
    setStatus,
    setCreditCardFormError,
    formErrors,
  ]);

  const onError = useCallback(() => {
    cleanStatus();
  }, [cleanStatus]);

  useToastStatus({
    status,
    error: 'Error al procesar el pago',
    onError,
  });

  return (
    <Box display="flex" flexDirection="column" gap="4" width="100%">
      {setupIsLoading && <CreditCardForm.Skeleton />}
      <CreditCardForm hidden={setupIsLoading}>
        <CreditCardForm.Fields
          formValues={formValues}
          setFieldValue={setFieldValue}
          errors={errors}
          country={country}
          recurrentPaymentCompatible={false}
        />
      </CreditCardForm>
    </Box>
  );
}
